import type { GanttBarViewModel } from "./types-gantt";

export function GanttBarView({
  className,
  labelClassName,
  style,
  tone,
  variant,
  dataPast,
  lane,
  testId,
  ariaLabel,
  label,
  onClick,
  rest,
}: GanttBarViewModel) {
  const props = {
    className,
    style,
    "data-tone": tone,
    "data-variant": variant,
    "data-past": dataPast,
    "data-lane": lane,
    "data-testid": testId,
    "aria-label": ariaLabel,
    ...rest,
  };
  const content = label ? <span className={labelClassName}>{label}</span> : null;

  return onClick ? (
    <button type="button" {...props} onClick={onClick}>
      {content}
    </button>
  ) : (
    <div {...props}>{content}</div>
  );
}
